import { Icon, IconProps } from "../archive";

export const Ekubo = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 134 134" {...props}>
      <g>
        <circle cx="67" cy="67" r="67" fill="url(#paint0_linear_1_30)" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30 54.0769C30 47.9593 34.9696 43 41.1 43H92.9C99.0304 43 104 47.9593 104 54.0769V79.9231C104 86.0407 99.0304 91 92.9 91H41.1C34.9696 91 30 86.0407 30 79.9231V54.0769ZM67 67C67 75.1568 60.3738 81.7692 52.2 81.7692C44.0262 81.7692 37.4 75.1568 37.4 67C37.4 58.8432 44.0262 52.2308 52.2 52.2308C60.3738 52.2308 67 58.8432 67 67ZM67 67C67 58.8432 73.6262 52.2308 81.8 52.2308C89.9738 52.2308 96.6 58.8432 96.6 67C96.6 75.1568 89.9738 81.7692 81.8 81.7692C73.6262 81.7692 67 75.1568 67 67Z"
          fill="currentColor"
        />
        <defs>
          <linearGradient id="paint0_linear_1_30" x1="0" y1="0" x2="134" y2="134" gradientUnits="userSpaceOnUse">
            <stop stopColor="#202F20" />
            <stop offset="1" />
          </linearGradient>
        </defs>
      </g>
    </Icon>
  );
};
